export default function CheckmarkIcon({fill} : any) {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m8.088 15.467-4.87-4.88a.754.754 0 0 1 0-1.06l1.06-1.06c.29-.29.77-.29 1.06 0l3.28 3.28 7.04-7.03c.29-.29.77-.29 1.06 0l1.06 1.06c.29.29.29.77 0 1.06l-8.62 8.63c-.29.29-.77.29-1.06 0h-.01z" fill={fill ? fill : "#E42436"}/>
    </svg>
  );
}
